import React, { Component } from 'react'
import { connect } from 'react-redux'
import SettingMenu from '../../../../constants/menu/setting'
import { Link } from 'react-router-dom'
import { authService, fvpCategoriesService, fvpRateTaxCodeService } from '../../../../services'

// UI
import { Button, Loading, Page, Pager, Panel, SideModal, List } from '../../../../components'
import Form from 'antd/lib/form'
import Switch from 'antd/lib/switch'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Select from 'antd/lib/select'
import Skeleton from 'antd/lib/skeleton'
import Popconfirm from 'antd/lib/popconfirm'
import message from 'antd/lib/message'

import './styles.css'
import notify from '../../../../components/Notification'
import { formatter, validator } from '../../../../util'
const pageSize = 20
const { Item: FormItem } = Form
const Option = Select.Option

const settingType = 'category'

export class SettingFundingCats extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPage: 1,
      filter: {},
      list: [],
      modal: {
        item: { link: {} },
        show: false
      },
      modalShow: false,
      loading: false,
      loadingForm: false,
      searchText: '',
      selectedItem: { _id: null },
      sort: {},
      total: 0,
      taxCodeList: []
    }
  }

  componentDidMount () {
    const { currentPage } = this.state
    this.fetchTaxCodeList()
    this.fetchCategories({ currentPage, loading: true })
  }

  fetchCategories = async ({ loading = false, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    try {
      if (this.hasAccess('listFvpFundingCategories')) {
        this.setState({ currentPage, loading: loading })
        const settings = await fvpCategoriesService.listByPage(currentPage, pageSize, {is_delete: false})
        this.setState({ list: settings.list, loading: false, total: settings.total })
      }
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load categories successfully. Please try again later.')
    }
  }

  fetchTaxCodeList = async () => {
    const tc = await fvpRateTaxCodeService.listAll()
    if (tc && validator.isNotEmptyArray(tc)) {
      this.setState({ taxCodeList: tc })
    }
  }

  hideModal = () => {
    const { form } = this.props
    const { modal } = this.state
    const { resetFields } = form
    resetFields()
    modal.item = { link: {} }
    modal.show = false
    this.setState({ modal, selectedItem: {} })
  }

  showModal = () => {
    const { modal } = this.state
    modal.show = true
    this.setState({ modal })
  }

  handleSave = () => {
    const { form } = this.props
    const { validateFields } = form
    const { selectedItem } = this.state

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = selectedItem
        const { modal } = this.state
        const { item } = modal
        this.setState({ loadingForm: true })

        try {
          let r

          if (id) {
            r = await fvpCategoriesService.save(id, values)
          } else {
            r = await fvpCategoriesService.add(values)
          }
          this.setState({ loadingForm: false })

          if (r && r.id) {
            const { id } = r
            modal.item = { ...item, ...values, id }

            this.setState({ modal })
            notify.success('Saved successfully', `${formatter.capitalize(settingType)} saved successfully.`)
            this.fetchCategories({ currentPage: this.state.currentPage })
            this.hideModal()
          } else {
            notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  handleEdit (item) {
    this.setState({ selectedItem: item })
    this.showModal()
  }

  async handleDelete (id) {
    const res = await fvpCategoriesService.remove(id)

    if (res) {
      message.success('Deleted successfully', `${formatter.capitalize(settingType)} deleted successfully`)
      this.fetchCategories({ currentPage: 1 })
    }
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  render () {
    const { currentPage, list, loading, loadingForm, modal, selectedItem, total, taxCodeList } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form

    const columns = [
      {
        title: 'Name',
        width: 12,
        key: 'name'
      },
      {
        title: 'Tax Code',
        width: 5,
        render: ({ tax_code_name }) => <div>{tax_code_name}</div>
      },
      {
        title: 'Enable',
        width: 2,
        render: ({ active }) => <div style={{ fontSize: '11pt' }}>{ active ? <Icon type='check-circle' theme='filled' /> : null }</div>
      },
      {
        title: 'Sleepover?',
        width: 2,
        render: ({ is_sleepover }) => <div style={{ fontSize: '11pt' }}>{ is_sleepover ? <Icon type='check-circle' theme='filled' /> : null }</div>
      },
      {
        title: '',
        width: 1,
        render: (item) => this.hasAccess('updateFvpFundingCategory')
          ? <div style={{ cursor: 'pointer' }} onClick={() => this.handleEdit(item)}><Icon type='form' /></div>
          : null
      },
      {
        title: '',
        width: 1,
        render: ({ id, is_sleepover }) => this.hasAccess('deleteFvpFundingCategory') && !is_sleepover
          ? <Popconfirm
            title='Confirm to delete this?'
            onConfirm={(e) => this.handleDelete(id)}
            okText='Yes'
            cancelText='No'
          ><Icon type='delete' />
          </Popconfirm>
          : null
      }
    ]

    return (
      <div>
        <Page.Header title='Categories'>
          {
            this.hasAccess('createFvpFundingCategory')
            ? <div className='btn' onClick={() => this.showModal()}>
              Add
            </div>
            : null
          }
        </Page.Header>

        <div className='setting-list'>
          <Skeleton loading={loading} active>
            <List cols={columns} rows={list} />

            <Pager
              size={pageSize}
              total={total}
              totalText={`Total ${total} categories`}
              current={currentPage}
              onChange={this.changePage}
              style={{ marginTop: '15px' }}
            />
          </Skeleton>
        </div>

        <SideModal
          title='Category'
          showModal={modal.show}
          onClose={this.hideModal}
          buttons={[
            this.hasAccess('updateFvpFundingCategory') || this.hasAccess('createFvpFundingCategory')
            ? <Button onClick={this.handleSave} feedback={loadingForm}>Save</Button>
            : null
          ]}
        >
          <Loading loading={loadingForm} blur>
            <Form layout='vertical'>
              <FormItem label='Category Name'>
                {getFieldDecorator('name', {
                  initialValue: selectedItem.name || null,
                  rules: [
                    { min: 2, message: 'Category Name must be between 2 and 128 characters' },
                    { max: 128, message: 'Category Name must be between 2 and 128 characters' },
                    { required: true, message: 'Please enter Category Name' },
                    { whitespace: true, message: 'Please enter Category Name' }
                  ]
                })(
                  <Input />
                )}
              </FormItem>
              <FormItem label='Tax Code'>
                {getFieldDecorator('tax_code_id', {
                  initialValue: selectedItem.tax_code_id || '',
                  rules: [
                    { required: true, message: 'Please select a tax code' }
                  ]
                })(
                  <Select
                    style={{ width: '100%' }}
                    placeholder='Please select a tax code'
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {
                      taxCodeList.map((c, idx) => {
                        return <Option key={c.id} value={c.id}>{c.name}</Option>
                      })
                    }
                  </Select>
                )}
              </FormItem>
              {/* <FormItem label='Sleepover?'>
                {getFieldDecorator('is_sleepover', {
                  initialValue: selectedItem.is_sleepover === undefined || selectedItem.is_sleepover === null ? false : selectedItem.is_sleepover,
                  valuePropName: 'checked'
                })(
                  <Switch
                    checkedChildren='Yes' unCheckedChildren='No'
                  />
                )}
              </FormItem> */}
              <FormItem label=''>
                {getFieldDecorator('active', {
                  initialValue: selectedItem.active === undefined || selectedItem.active === null ? true : selectedItem.active,
                  valuePropName: 'checked'
                })(
                  <Switch
                    checkedChildren='Enable' unCheckedChildren='Disable' disabled={selectedItem.is_sleepover}
                  />
                )}
              </FormItem>
            </Form>
          </Loading>
        </SideModal>
      </div>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchCategories({ loading: true, currentPage, filter, sort, searchText })
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(SettingFundingCats))
